// Import Global Contexts
import {useCalculatorContext } from '../contexts/CalculatorContext';
// Import Functions
import formatToMoney from "../functions/formatToMoney";
import {toNumeric} from "./../functions/generalFunctions";
//Import Assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faXmark} from '@fortawesome/free-solid-svg-icons'

const ModalForm = () => {

    // Use the Global Calculator Context 
     const {
        modalForm, setModalForm, history,
        setCurrentPremim, activePremium
    } = useCalculatorContext();

    // Funciones
    const loadAndMountCognito = (shareData) => {
        // Esperar a que el script cargue, y luego montar el formulario
        const waitForCognito = setInterval(() => {
            if (window.Cognito) {
                clearInterval(waitForCognito);

                const formData = {
                    "Premium": formatToMoney(shareData.premium),
                    "MinimumPremium": shareData.minPremium + " ",
                    "ShipmentValue": formatToMoney(shareData.fob),
                    "Rate": shareData.rate + " ",
                    "CalculatorLink": shareData.pageUrl,
                };
                // Montamos el formulario
                window.Cognito.mount(2, ".cognito").prefill(formData);
            }
        }, 100);
    };

    const closeModalForm = () => {

        // Update the active premium
        setModalForm({
            visible: false,
            premiumId: null
        });

        // Clean the Cognito Wrapper
        const cognitoWrapper = document.querySelector(".cognito-wrapper");
        if (cognitoWrapper) cognitoWrapper.innerHTML = "<div className='cognito'></div>";

        // Setting back all the data to the calculator form
        setCurrentPremim(activePremium)
    }

    // Retornar null si el modal no está visible
    if (!modalForm.visible) return null;

    // Get the desired premium data
    let shareData;
    history.map((el)=>{
        if(el.id == modalForm.premiumId){
            shareData = {
                fob: toNumeric(el.fob),
                flete: toNumeric(el.flete),
                tax: toNumeric(el.tax),
                extraExpensesCheck: el.extraExpensesCheck,
                operationalExpensesCheck: el.operationalExpensesCheck,
                rate: toNumeric(el.rate),
                minPremium: toNumeric(el.minPremium),
                subtotal: toNumeric(el.subtotal),
                extraExpenses: toNumeric(el.extraExpenses),
                operationalExpenses: toNumeric(el.operationalExpenses),
                totalInsured: toNumeric(el.totalInsured),
                premium: toNumeric(el.premium),
            };
        }
    });

   if (shareData) {
        const params = new URLSearchParams(shareData);
        shareData.pageUrl = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
    }

    console.table(shareData);

    loadAndMountCognito(shareData);
  
<FontAwesomeIcon icon="fa-solid fa-xmark" />
    return (
        <div className="modal-overlay">
            <div className='modal-form-container'>
                <button className="btn-close" onClick={()=>closeModalForm()}><FontAwesomeIcon icon={faXmark} /></button>
                <h2>Comparte esta prima</h2>
                <p>Si desea compartir esta prima con usted mismo o con otra persona, complete el formulario a continuación</p>
                <div className='cognito-wrapper'><div className='cognito'></div></div>
            </div>
        </div>

     );
}
 
export default ModalForm;